import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from "../../../../base.component";
import { Store } from "@ngrx/store";
import { selectPanelState } from "@store/doc-viewer/panel/panel.selectors";
import { Observable } from 'rxjs';
import { PanelActions } from "@store/doc-viewer/panel/panel.actions";
import { PanelState } from "@store/doc-viewer/panel/panel-state";

@Component({
    selector: 'lex-doc-viewer-coding-section',
    templateUrl: './doc-viewer-coding-section.component.html',
    styleUrls: ['./doc-viewer-coding-section.component.scss'],
    standalone: false
})
export class DocViewerCodingSectionComponent extends BaseComponent implements OnInit {
	@Input() disabled: boolean = false;
	@Input() panelId: string;
	public panelState$: Observable<PanelState>;

	constructor(
		private store: Store
	) {
		super();
	}

	public ngOnInit(): void {
		this.panelState$ = this.store.select(selectPanelState({panelId: this.panelId}));
	}

	public dispatchPanelCollapsed(): void {
		this.store.dispatch(PanelActions.collapsePanel({panelId: this.panelId}));
	}

	public dispatchPanelExpanded(): void {
		this.store.dispatch(PanelActions.expandPanel({panelId: this.panelId}));
	}
}
